<div style="background-color: #F5F7F8; height: 100vh; overflow-y: hidden; padding: 10px; padding-top: 20px;">
    <img style="width: 22px; height: 22px; position: absolute; top: 25px; left: 20px;" (click)="this.back()" src="/assets/images/shared/back.svg">
    <h2 style="text-align: center;">Добави карта</h2>
    <div style="width: 100%; margin: auto; padding: 10px;">
        <input (change)="this.setCardholder($event)" style="margin-bottom: 10px;" type="text" class="form-control" placeholder="Име на картодържателя" aria-label="Username" aria-describedby="basic-addon1">
        <div class="form-control" style="margin-bottom: 10px;" id="card-number"></div>
        <div class="row justify-content-around" style="margin-bottom: 10px;">
            <div class="col-5 form-control" id="card-expiry">

            </div>
            <div class="col-5 form-control" id="card-cvc">

            </div>
        </div>
        <div style="position: fixed; bottom: 35px; text-align: center; width: 90%; margin: auto; left: 5%;">
            <button id="card-button" class="btn-primary btn" style="width: 100%; margin: auto; height: 45px;">Запази</button>
        </div>
    </div>
</div>